// Shared formatting for product pricing, used by the detail page and the cart.

// Term codes returned by the API → human labels / price suffixes / billed months
// / billing-cadence adverb. A monthly (Term 1) price is per-month billed monthly;
// an annual (Term 2) price is the full-year amount billed once annually.
export const TERM_LABELS = { 1: 'Monthly', 2: 'Annual' };
export const TERM_SUFFIX = { 1: '/mo', 2: '/yr' };
export const TERM_MONTHS = { 1: 1, 2: 12 };
export const TERM_CADENCE = { 1: 'monthly', 2: 'annually' };

export const termLabel = term => TERM_LABELS[term] || `Term ${term}`;
export const termCadence = term => TERM_CADENCE[term] || '';

// Look up the price (USD) for a term + seat count in a flat price list.
export function priceFor(prices, term, seatCount) {
  return (prices || []).find(p => p.Term === term && p.SeatCount === seatCount)?.PriceUSD ?? 0;
}

// Distinct seat counts offered for a given term, sorted ascending.
export function seatCountsForTerm(prices, term) {
  return [...new Set((prices || []).filter(p => p.Term === term).map(p => p.SeatCount))]
    .sort((a, b) => a - b);
}

// Distinct terms present in a price list, sorted ascending.
export function termsIn(prices) {
  return [...new Set((prices || []).map(p => p.Term))].sort((a, b) => a - b);
}

export const usd = new Intl.NumberFormat('en-US', {
  style: 'currency',
  currency: 'USD',
  minimumFractionDigits: 2,
  maximumFractionDigits: 2,
});
